import {Component, forwardRef, Injector} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {ScreenLayoutSearchModel} from "../screen-layout-search.model";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {ScreenLayoutSearchPageComponent} from "../screen-layout-search-page/screen-layout-search-page.component";
import {
    AbstractSingleSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-single-select-edit-control.component";
import {ScreenLayoutEditPageComponent} from "../screen-layout-edit-page/screen-layout-edit-page.component";

const CUSTOM_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => ScreenLayoutSingleSelectEditControlComponent),
    multi: true
};

@Component({
    selector: "wbo-screen-layout-single-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component.html",
    providers: [
        CUSTOM_VALUE_ACCESSOR,
        provideSearchModel(ScreenLayoutSearchModel)
    ]
})
export class ScreenLayoutSingleSelectEditControlComponent extends AbstractSingleSelectEditControlComponent<ScreenLayoutSearchModel> {
    constructor(model: ScreenLayoutSearchModel, injector: Injector) {
        super(model, injector, "confId", "name");

        this.extendedSearchComponent = ScreenLayoutSearchPageComponent;
        this.extendedEditComponent = ScreenLayoutEditPageComponent;
    }
}
